export const renderPagination = (pagination, onPageLinkClick) => {
    const paginationContainer = document.querySelector('.js-pagination');
    paginationContainer.innerHTML = '';

    const buttonBaseClasses = [
        'btn', 'btn-pagination'
    ];
    const currentPageClasses = ['btn-pagination-selected'];

    const createButton = (text, page, isCurrent = false, isDisabled = isCurrent, extraClasses = []) => {
        const button = document.createElement('button');
        button.textContent = text;
        button.classList.add(...buttonBaseClasses, ...extraClasses);
        if (isCurrent) {
            button.classList.add(...currentPageClasses);
        } else {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                onPageLinkClick(page);
            });
        }

        if (isDisabled) {
            button.disabled = true;
        }
        return button;
    };

    const createEllipsis = () => {
        const ellipsis = document.createElement('span');
        ellipsis.textContent = '...';
        ellipsis.classList.add('body-normal', 'body-bold', 'sm:px-2', 'mt-1.5');
        return ellipsis;
    };

    // Convenience methods for appending elements to the container
    const appendButton = (text, page, isCurrent = false, isDisabled = isCurrent, extraClasses = []) => {
        paginationContainer.appendChild(createButton(text, page, isCurrent, isDisabled, extraClasses));
    };

    const appendEllipsis = () => {
        paginationContainer.appendChild(createEllipsis());
    };

    const { current_page, total_pages } = pagination;

    if (!total_pages) {
        return;
    }

    // Add "Previous" button
    appendButton('', Math.max(current_page - 1, 1), false, current_page === 1, ['arrow-left']);

    // Add numbered page links
    if (total_pages <= 5) {
        // Display all pages if total pages are 5 or fewer
        for (let i = 1; i <= total_pages; i++) {
            appendButton(i, i, i === current_page);
        }
    } else {
        // Display pagination based on the current page
        if (current_page <= 3) {
            // Case: Current page is 1, 2, or 3
            for (let i = 1; i <= 4; i++) {
                appendButton(i, i, i === current_page);
            }
            appendEllipsis();
            appendButton(total_pages, total_pages);
        } else if (current_page >= total_pages - 2) {
            // Case: Current page is 3rd to last, 2nd to last, or last
            appendButton(1, 1);
            appendEllipsis();
            for (let i = total_pages - 3; i <= total_pages; i++) {
                appendButton(i, i, i === current_page);
            }
        } else {
            // Case: Current page is somewhere in the middle
            appendButton(1, 1);
            appendEllipsis();
            appendButton(current_page - 1, current_page - 1);
            appendButton(current_page, current_page, true);
            appendButton(current_page + 1, current_page + 1);
            appendEllipsis();
            appendButton(total_pages, total_pages);
        }
    }

    // Add "Next" button
    appendButton('', Math.min(current_page + 1, total_pages), false, current_page >= total_pages, ['arrow-right']);
};
